import * as jQuery from 'jquery';

export class CustomSwalCSS {
	static SetTitleTextColor = () => jQuery('.swal2-title').css('color', '#ffffff8a');

	static SetBackgroundImageColor = () => jQuery('.swal2-modal').css('background-color', '#090901');

	static AddBorder = () =>
		jQuery('.swal2-modal')
			.css('border-width', '4px')
			.css('border-style', 'solid')
			.css('border-image', 'url("/images/other_backgrounds/swalbordernami.png") 39% / 2 / 0 round');
}
